<template>
  <div class="pro-tutorial-wrapper">
    <div class="our-solutions-badge">How it works</div>
    <div class="row mb-5">
      <div class="col-lg-8 col-12 p-0">
        <div class="individual-tutorial-title">
          Easy to Start, Built for Your Professional Life
        </div>
        <div class="individual-tutorial-desc">
          Start learning job-relevant Spanish that fits seamlessly into your
          demanding schedule.
        </div>
      </div>
      <div class="col-lg-4 col-12 p-0" v-if="!isMobile">
        <div class="individuals-tutorial-watch">
          <div class="individuals-tutorial-watch-video">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/QvJJER1Z0Cc?si=HHqhCDOR9pRWcryE"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <div class="individuals-tutorial-watch-button">
            Watch now how it works
          </div>
        </div>
      </div>
    </div>
    <div>
      <v-timeline
        align="start"
        side="end"
        :direction="isMobile ? 'vertical' : 'horizontal'"
      >
        <v-timeline-item
          class="individual-tutorial-timeline"
          :dot-color="item.color"
          dot
          large
          v-for="(item, i) in getCollaborationsTimelineProfessional"
          :key="i"
        >
          <template v-slot:icon>
            <span>{{ i + 1 }}</span>
          </template>
          <div class="collaborations-timeline">
            <div class="individual-tutorial-timeline-title">
              {{ item.title }}
            </div>
            <div class="individual-tutorial-timeline-desc">{{ item.desc }}</div>
          </div>
        </v-timeline-item>
      </v-timeline>
    </div>
    <div class="individuals-tutorial-trial-button">
      <md-filled-tonal-button
        class="get-started-button"
        @click="$router.push('/book-demo')"
      >
        Book Your Free Trial Now
        <i class="mdi mdi-arrow-right"></i>
      </md-filled-tonal-button>
    </div>
    <div class="" v-if="isMobile">
      <div class="individuals-tutorial-watch-video">
        <iframe
          src="https://drive.google.com/file/d/1vkmQ49uzBWG8MwNZ2QX-KdshKlAFXRej/preview"
          frameborder="0"
          allowfullscreen
          width="100%"
          height="100%"
        ></iframe>
      </div>
      <div class="individuals-tutorial-watch-button">
        Watch now how it works
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "professionalTutorial",
  computed: {
    ...mapGetters(["getNotification", "getCollaborationsTimelineProfessional"]),
    ...mapState(["notification"]),
    width() {
      return window?.screen?.width;
    },
    isMobile() {
      return this.width <= 800;
    },
  },
  methods: {
    ...mapMutations(["setNotification"]),
  },
};
</script>

<style></style>
